export default function toggle() {
    return {
        checked: false,

        get checkedAttr() {
            return String(this.checked);
        },

        get trackClass() {
            return this.checked ? 'bg-primary' : 'bg-muted';
        },

        get knobClass() {
            return this.checked ? 'translate-x-5' : 'translate-x-0';
        },

        toggle() {
            this.checked = !this.checked;
        },

        init() {
            if (this.$el.dataset.checked === 'true') {
                this.checked = true;
            }
        },

        destroy() {},
    };
}
